import React from "react";

import { Media } from "../../contexts/media/MediaContext";
import useBreakpoint from "../../hooks/use-breakpoint/useBreakpoint";
import { DynamicCardContainerContent, FeatureToggle, IconPack } from "../../models/app-data-model";
import DynamicCardGrid from "../dynamic-card-grid/dynamic-card-grid";
import DynamicCardSlider from "../dynamic-card-slider/dynamic-card-slider";
import "./dynamic-card-container.scss";

export type DynamicCardContainerProps = {
  content: DynamicCardContainerContent;
  featureToggles: FeatureToggle[];
  iconPack: IconPack[];
  dynamicContainerOverride: boolean;
};

// This component is used in the Dynamic card grid, Dynamic Tabbed components, or any other dynamic component similar to those two as a wrapper/container

const DynamicCardContainer: React.FC<DynamicCardContainerProps> = ({
  content,
  iconPack,
  featureToggles,
  dynamicContainerOverride
}: DynamicCardContainerProps) => {
  const breakpoint = useBreakpoint();
  const renderCards = (cardWidth: number, layout?: string) => {
    return (
      <>
        {(layout?.toLowerCase() == "grid" || layout?.toLowerCase() == "condensed_grid" || !dynamicContainerOverride) && (
          // card slider layout is only supported inside a dyanmic container.
          // If it is included anywhere besides a dyanmic container do not render slider even if it is selected in content.
          <DynamicCardGrid
            content={content?.card_configurations}
            cardWidth={cardWidth}
            condensedGrid={layout?.toLowerCase() == "condensed_grid"}
            iconPack={iconPack}
          />
        )}
        {layout?.toLowerCase() == "slider" && dynamicContainerOverride && (
          <DynamicCardSlider content={content?.card_configurations} featureToggles={featureToggles} iconPack={iconPack} />
        )}
      </>
    );
  };

  return (
    <div className={`dynamic-card-container ${dynamicContainerOverride ? "add-margin-top" : ""}`}>
      <Media at="mobile">{renderCards(1, content?.container_mobile_layout)}</Media>
      <Media at="tablet">{renderCards(1, content?.container_desktop_layout)}</Media>
      <Media at="desktop">
        {renderCards(
          content?.container_column! === 2 || content?.container_column! === 4 ? 2 : content?.container_column!,
          content?.container_desktop_layout
        )}
      </Media>
      <Media greaterThanOrEqual="xl">{renderCards(content?.container_column!, content?.container_desktop_layout)}</Media>
    </div>
  );
};

export default DynamicCardContainer;
